import AppConstants from '../config/app.constants';

let RouteDetailService = function ($http, $q) {

    let getRoutesForBranch = (branchId, date, completed) => {
        return $http
            .get(AppConstants.api + `/route-detail/${branchId}`, {
                params: {
                    date,
                    completed
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let routeUpdateDetails = (branchId, routeId, vaultDate, vehicleId, messengerId, driverId, guardId,
                              leaveTime, arriveTime, begMiles, endMiles) => {
        return $http
            .post(AppConstants.api + `/route-detail/route-update-detail`, {
                branchId,
                routeId,
                vaultDate,
                vehicleId,
                messengerId,
                driverId,
                guardId,
                leaveTime,
                arriveTime,
                begMiles,
                endMiles
            })
            .then((res) => {
                return res.data
            })
    }

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/route-detail`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let pickupDeliveryShipments = (branchId, routeId, vaultDate, flagType) => {
        return $http
            .get(AppConstants.api + `/route-detail/${branchId}/pickup-delivery-shipments`, {
                params: { routeId, vaultDate, flagType, branchId }
            })
            .then((res) => {
                return res.data
            })
    }

    let updateMessenger = (branchId, routeId, vaultDate, messengerId) => {
        return $http
            .post(AppConstants.api + `/route-detail/update-messenger`, {
                branchId,
                routeId,
                vaultDate,
                messengerId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getRoutesForBranch,
        routeUpdateDetails,
        updateMessenger,
        all,
        pickupDeliveryShipments
    };
};

RouteDetailService.$inject = ['$http', '$q']

export default RouteDetailService;



// WEBPACK FOOTER //
// ./client/app/services/route-detail.service.js